(function() {

    // Volume selector: toggle active state on vol-btn clicks
    document.addEventListener('click', function(event) {
        var volBtn = event.target.closest('.vol-btn');
        if (volBtn) {
            volBtn.closest('.volume-grid').querySelectorAll('.vol-btn').forEach(function(b) {
                b.classList.remove('active');
            });
            volBtn.classList.add('active');
        }
    });

    // Keep the mobile-header inventory copy in sync with the original element
    // (the theme updates the original by ID when a variant changes)
    var inventoryEl = document.querySelector('[id^="inventory-"]');
    var mobileInventoryEl = document.querySelector('.product__mobile-inventory');
    if (inventoryEl && mobileInventoryEl) {
        new MutationObserver(function() {
            mobileInventoryEl.innerHTML = inventoryEl.innerHTML;
        }).observe(inventoryEl, { childList: true, subtree: true });
    }

    // Keep the mobile-header title copy in sync with the desktop <h1>.
    // Variant Title King (app embed) only rewrites heading elements (h1-h6) whose text
    // contains the product title, so it updates the desktop <h1> but never the <p>
    // rendered in the mobile header. Mirror the <h1> text into that <p> on load and
    // whenever the app (or anything else) changes it.
    var desktopTitleEl = document.querySelector('.product__right-column h1.product__title');
    var mobileTitleEl = document.querySelector('.product__mobile-header .product__title');
    if (desktopTitleEl && mobileTitleEl) {
        var syncMobileTitle = function() {
            var text = desktopTitleEl.textContent.trim();
            if (text && mobileTitleEl.textContent !== text) {
                mobileTitleEl.textContent = text;
            }
        };
        syncMobileTitle();
        new MutationObserver(syncMobileTitle).observe(desktopTitleEl, { childList: true, characterData: true, subtree: true });
    }

    // Shorten FSC certification labels in variant picker buttons and dropdowns
    // "FSC mix 70%", "FSC mix credit", "FSC 100%" → "FSC"
    var fscPattern = /FSC\s+(mix\s+\d+%?|mix\s+credit|\d+%)/gi;
    // Button picker: <label><span>value</span></label>
    document.querySelectorAll('.product-form__item--zoom label span').forEach(function(span) {
        span.textContent = span.textContent.replace(fscPattern, 'FSC');
    });
    // Dropdown picker: <select><option>value</option></select>
    document.querySelectorAll('variant-selects select option, .single-option-selector option').forEach(function(opt) {
        opt.textContent = opt.textContent.replace(fscPattern, 'FSC');
    });

    // On mobile: physically move the Trustpilot widget into the mobile header,
    // right after the inventory block (single DOM element keeps JS initialization intact)
    if (window.matchMedia('(max-width: 650px)').matches) {
        var trustpilotWidget = document.querySelector('[id^="ProductInfo"] .trustpilot-widget');
        var mobileInventoryBlock = document.querySelector('.product__mobile-inventory');
        if (trustpilotWidget && mobileInventoryBlock) {
            mobileInventoryBlock.parentNode.insertBefore(trustpilotWidget, mobileInventoryBlock.nextSibling);
        }
    }

})();
